import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

class BasketFooter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showNote:
        (this.props.basketCount < 10 && this.props.basketCount > 0) ||
        this.props.replacementCount > 0,
    };
  }
  toggleSaveOrderDialog = () => {
    this.props.dispatch({ type: "TOGGLE_SAVE_ORDER_DIALOG" });
  };
  closeBasket = () => {
    this.props.dispatch({ type: "TOGGLE_BASKET_DROPDOWN" });
  }
  render() {
    return (
      <div>
        <Row className={this.state.showNote ? "" : "hidden"}>
          <Col lg={12}>
            <div className="basket-note">
              {this.props.basketCount < 10 && this.props.basketCount > 0 && (
                <p>
                  please note there is a minimum order quantity of 10 outers
                </p>
              )}
              {this.props.replacementCount > 0 && (
                <p>
                  DUE TO SOME PRODUCTS BEING OUT OF STOCK, REPLACEMENT PRODUCTS
                  HAVE BEEN ADDED TO YOUR BASKET, THE QUANTITY OF WHICH IS BASED
                  ON YOUR PREVIOUS ORDER HISTORY. PLEASE REVIEW THESE BEFORE
                  CHECKOUT
                </p>
              )}
            </div>
          </Col>
        </Row>

        <Row className="basket-footer">
          <Col sm={9}>
            <span className="h4">Basket Total:</span>
            <span className="h3 total-money">
              €{this.props.basketTotalWithCurrentPromotions.toFixed(2)}
            </span>
          </Col>
          <Col md={3}>
            <Link to="/order/new/confirm">
              <Button
                className="btn btn-check-out text-uppercase"
                disabled={this.props.basketCount < 10}
                onClick={this.closeBasket}
              >
                check out
              </Button>
            </Link>
          </Col>
        </Row>
        <Row>
          <Col>
            <Button
              className="btn btn-link pull-left"
              onClick={this.toggleSaveOrderDialog}
              disabled={this.props.basketCount === 0}
            >
              Save for later
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  basketCount: Object.values(state.orders.new.basket.line_items).reduce(
    (sum, { product_qty }) => sum + product_qty,
    0
  ),
  replacementCount: state.orders.new.basket.replacements.length,
  basketTotalWithCurrentPromotions:
    state.orders.new.basket_total_with_current_promotions,
});
export default connect(mapStateToProps)(BasketFooter);



// WEBPACK FOOTER //
// ./src/components/new-order/basket/basket-footer.jsx